import BaseService from '../BaseService'
import axios from "axios";

class CustomerFeedbackService extends BaseService {
    constructor() {
        super('/customer-feedback');
    }

    store ({ payload }) {
        return axios.post(`${this.resource}?notificationOff`, payload)
    }
}

export default new CustomerFeedbackService()
